import Mustache from 'mustache';
import helper from './helper';

let autoCloseTimeout = null;
const removeTimeout = [];

const template = `<div class="notification{{#status}} notification--{{status}}{{/status}}">
    <div class="sst-center-block">
        <div class="notification__inner">
            {{message}}
            <button class="close-notification">
                <svg version="1.1" height="20" width="14" viewBox="0 0 14 20" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-close "><path d="M14,4.41L12.59,3L7,8.59L1.41,3L0,4.41L5.59,10L0,15.59L1.41,17L7,11.41L12.59,17L14,15.59L8.41,10L14,4.41z"></path></svg>
            </button>
        </div>
    </div>
</div>`;

function closeNotification(el) {
    helper.slideUp(el, 0.2, function () {
        el.remove();
    });
}

function showNotification(el) {
    clearTimeout(autoCloseTimeout);
    for (var i = 0; i < removeTimeout.length; i++) {
        clearTimeout(removeTimeout[i]);
    }
    helper.slideDown(el, 0.2);
    runTimeout();
}

$(document).on('click', '.close-notification', function () {
    closeNotification($(this).closest('.notification'));
});

$(document).on('mouseover', '#notifications', function () {
    clearTimeout(autoCloseTimeout);
    for (var i = 0; i < removeTimeout.length; i++) {
        clearTimeout(removeTimeout[i]);
    }
});

$(document).on('mouseout', '#notifications', function () {
    runTimeout();
});

function runTimeout() {
    autoCloseTimeout = setTimeout(function () {
        $('#notifications')
            .children('.notification')
            .each(function (index, el) {
                (function (x) {
                    var rt = setTimeout(function () {
                        closeNotification(x);
                    }, index * 300);
                    removeTimeout.push(rt);
                })(el);
            });
    }, 4000);
}

export default function (notification) {
    /*
     *	notification = {
     *		status: String
     *		message: String
     *	}
     */

    var notification = $(Mustache.render(template, notification));
    $('#notifications').prepend(notification);
    showNotification(notification);
}
